// Definció de l'estructura IConfig que es configura a ./public/config.json

// Defincició d'una capa
export interface ILayer {
    type: string; // Tipus de capa de moment accepta 'wms' i 'wmts'
    url: string, // URL del servidor on hi ha la capa. p.ex.: 'http://shagrat.icc.es/lizardtech/iserv/ows?'
    layers: string, // Capes a demanar al servidor. p.ex.: 'orto5m'
    name: string, // Nom descriptiu de la capa, p.ex.: 'ICGC (ortofoto)'
    singleTile: boolean; // Si és true la capa és demana d'un sol cop, si és fales es demana per tesseles
    matrixSet: string; // Si és una capa WMTS el nom del TileMatrixSet que s'ha d'utilitzar
    cap?: any; // Capabilities dels WMTS -> No s'ha d'informa al config.json, es llegirà al començar l'aplicació
};

// Defincició d'una categoria
export interface ICat {
    cat: number; // Categoria 1 - més bona 5 - més dolenta 0 - no definida
    color: string; // Color de la categoria
    max: number; // Màxim de fanals a la categoria (0 - sense límit)
}

// Una línia d'un URL de descàrrega
export interface IUrl {
    name: string, // Nom descriptiu de la línia de descàrrega
    url: string // URL de la descàrrega. p.ex.: 'http://www.manresa.cat/docs/sig/guia_manresa.pdf'
}

// Totes les defincions necessàries per el programa
export interface IMapConfig {
    baseLayers: ILayer[], // Capes base
    refLayers: ILayer[], // Capes de referència
    wmsUrl: string, // URL del WMS estàndard
    wmsELEUrl: string, // URL del WMS de les eleccions
    wfsUrl: string, // URL del WFS estàndard
    wsUrl: string, // URL del WebService de les adreces
    imgEmplUrl: string, // URl de les imatges dels emplaçaments
    mapLotsUrl: string, // URl per demanar el mapa de lots
    adrWebApiUrl: string; // URL del WebAPi del widget de la referèncioa cadastral
    eleCod?: number; // Codi de l'elecció. Si no hi és o és 0 agafarà l'elecció actuaL
    categories: ICat[]; // Colors de le scategories
    helpUrl: string; // Url de la pantalla d'ajuda
    descarrega: IUrl[] // URLs a afegir al desplegable de descàrregues
}

// Confiuració buida per inicialitzar
export class EmptyMapConfig implements IMapConfig {
    baseLayers = []; // Capes base
    refLayers = []; // Capes de referència
    wmsUrl = '';
    wmsELEUrl = '';
    wfsUrl = '';
    wsUrl = '';
    imgEmplUrl = '';
    mapLotsUrl = '';
    adrWebApiUrl = '';
    eleCod = 0;
    categories = [];
    helpUrl = ''; // Url de la pantalla d'ajuda
    descarrega = []; // URLs a afegir al desplegable de descàrregues
}